'use client';
import React from 'react';
import { Div, Text } from '@pezeshk-book/ui-kit';
import routes from '@routes';
import Link from 'next/link';
import getParseRoute from '@utils/helpers/parse-route';
import PostItemSchema from '@schema/post/post-item';
import { useParams } from 'next/navigation';
import { LocaleTypes } from '@dictionaries-types';

const RelatedPosts = ({ item }: { item: any }) => {
  const { lang } = useParams<{lang: LocaleTypes}>();
  return (
    <Div className={'grid grid-cols-1 md:grid-cols-2 w-full gap-x-6 gap-y-3 md:gap-y-6 justify-center items-center'}>
      {item && item.map((post: any) => {
        return (
          <Link
            itemType={'https://schema.org/BlogPosting'}
            itemScope
            key={`post_item_${post.id}`}
            href={getParseRoute({ pathname: routes['route.posts.show'], query: { slug: post.slug }, locale: lang })}
            passHref={true}
            className={'bg-darkBlue-50 shadow-lg w-full py-4 md:py-6 rounded-lg md:rounded-2xl items-center px-2 sm:px-6'}>
            <Text color={'tertiary'} type={'bold'} align={'start'}>{post.title}</Text>
            <PostItemSchema
              slug={post?.slug}
              publishedAt={post?.published_at}
              image={post?.image}
            />
          </Link>
        );
      })}
    </Div>
  );
};

export default RelatedPosts;
